import { UITypes } from "types"

import { IntelligenceReportsKeyIndicatorCell } from "components/table/columnComponents/IntelligenceReportsKeyIndicatorCell"
import { IntelligenceReportsPriorityCell } from "components/table/columnComponents/IntelligenceReportsPriorityCell"

import { ReportingPeriodCell } from "./ReportingPeriodCell"

const customerDashboardReportsTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Key indicators",
    type: "default",
    name: "key_indicators",
    size: "large",
    cellComponent: IntelligenceReportsKeyIndicatorCell,
  },
  {
    title: "Status",
    type: "default",
    name: "priority",
    size: "small",
    cellComponent: IntelligenceReportsPriorityCell,
  },
  {
    title: "Reporting period",
    type: "default",
    name: "reporting_period",
    size: "middle",
    cellComponent: ReportingPeriodCell,
  },
]

export default customerDashboardReportsTableHeaderCells
